<template>
  <v-data-table
    :headers="headers"
    :items="items.filter(x => x.est_intermediaire === false)"
    :search="search"
    item-key="id"
    sort-by="difference"
    :sort-desc="false"
  >
    <template v-slot:item.difference="{ item }">
      <v-chip
        outlined
        v-if="item.difference != 0"
        :color="item.difference > 0 ? 'accent' : 'error'"
      >
        {{ item.difference }}</v-chip
      >
    </template>
    <template v-slot:top>
      <v-row justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            hide-details
            single-line
            clearable
            append-icon="fa-search"
            v-model="search"
            class="pt-0 mb-1"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "PreparationSlipEditorPrimaryProductGrid",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: "",
      headers: [
        { value: "name", text: "Nom" },
        { value: "quantity_inventory", text: "Quantité en inventaire" },
        {
          value: "quantity_required_recipe",
          text: "Quantité nécessaire pour la production"
        },
        { value: "difference", text: "Écart" }
      ]
    };
  }
};
</script>

<style></style>
